// v66 — live streamer profile helpers (pure; no imports).
const RANK = { none: 1, low: 2, medium: 3, high: 4 };

// Overall bot risk: the higher of the two checks; a missing check is skipped.
export function overallBot(sub, live) {
  const a = RANK[sub] ? sub : null;
  const b = RANK[live] ? live : null;
  if (!a && !b) return null;
  if (!a) return b;
  if (!b) return a;
  return RANK[a] >= RANK[b] ? a : b;
}

export function fmtMins(m) {
  if (m == null) return "—";
  const t = Math.round(m);
  const h = Math.floor(t / 60);
  const mm = t % 60;
  if (!h) return `${mm}m`;
  return `${h}h ${String(mm).padStart(2, "0")}m`;
}

export function fmtX(n) {
  if (n == null || !Number.isFinite(n)) return null;
  return n >= 10 ? String(Math.round(n)) : n.toFixed(1).replace(/\.0$/, "");
}

export const PERIODS = [
  { k: "1d", label: "1D", words: "last 1 day" },
  { k: "7d", label: "7D", words: "last 7 days" },
  { k: "30d", label: "30D", words: "last 30 days" },
  { k: "90d", label: "90D", words: "last 90 days" },
  { k: "all", label: "All", words: "since 25 May" },
];

export const CADENCES = [
  { k: "daily", label: "Daily" },
  { k: "weekly", label: "Weekly" },
  { k: "monthly", label: "Monthly" },
];

export const GROUP_PILL = { frequent: "Frequent live streamer", regular: "Regular live streamer", rare: "Rare live streamer" };
